<template>
    <app-layout>
        <template v-slot:header>
            <h2 class="font-bold text-4xl dark:text-gray-200">
                Edit template
            </h2>
        </template>

        <div>
            <survey-template-editor :survey-types="$page.props.surveyTypes"
                                    :survey-template-model="surveyTemplateModel"
                                    :survey-question-types="$page.props.surveyQuestionTypes"
                                    :answer-label-options="$page.props.answerLabelOptions"
            />
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import SurveyTemplateEditor from "@/Components/SurveyTemplateEditor";

export default {
    components: {
        AppLayout,
        SurveyTemplateEditor,
    },
    props: {
        surveyTemplateModel: Object,
    },
}
</script>
